module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cm3nI"))).then(() => parcelRequire('fThBo'));